import React, { useState, useEffect } from 'react';

const Slide = () => {
    const content = [
        {
            quote: "Accurate Diagnosis of Biotinidase Deficiency",
            author: "Hope and determination are key to overcoming obstacles. A patient with unexplained neurological symptoms and low biotinidase levels faced a diagnostic dilemma: symptoms overlapped with other complex conditions. Using RDx, clinicians pinpointed Biotinidase Deficiency, enabling targeted treatment that significantly improved patient outcomes."
        },
        {
            quote: "Early Identification of Mitochondrial Myopathy",
            author: "Chronic fatigue, muscle weakness, and multisystem involvement left a patient without clear answers until we used RDx. By analysing the diverse clinical data through its advanced algorithm, RDx detected a rare mitochondrial mutation, confirming mitochondrial myopathy. This early diagnosis allowed for timely, personalized interventions, enhancing the patient’s quality of life."
        },
        {
            quote: "Precision Diagnosis of Congenital Myasthenic Syndrome",
            author: "A newborn with muscle weakness and respiratory distress faced a wide range of possible conditions. Using its advanced phenotype-to-genotype analysis, RDx identified the specific genetic mutation responsible for congenital myasthenic syndrome. This definitive diagnosis led to immediate, targeted therapy, dramatically improving the newborn's prognosis."
        },
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % content.length);
        }, 7000);

        return () => clearInterval(interval);
    }, [content.length]);

    const goToNextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % content.length);
    };

    const goToPreviousSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + content.length) % content.length);
    };

    return (
        <div className="w-full h-[500px] overflow-hidden relative bg-blue-100 py-20">
            {/* Constant Heading and Subheading */}
            <div className="absolute top-0 w-full text-center z-10">
                <h1 className='flex justify-center text-[40px] text-[#1E3A8A] leading-[26px] font-bold text-center w-500px mt-2 pt-20'>
                    Real-World Success Stories with RDx
                </h1>
                <p className="flex justify-center mx-auto text-[18px] text-[#000] leading-[22px] font-medium text-center mt-2 font-medium pt-6">
                    Discover how RDx is transforming rare disease diagnosis and empowering doctors worldwide
                </p>
            </div>

            {/* Arrows */}
            <div
                onClick={goToPreviousSlide}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 cursor-pointer z-20"
            >
                <span className="text-black text-4xl">&#10094;</span> {/* Left arrow */}
            </div>
            <div
                onClick={goToNextSlide}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer z-20"
            >
                <span className="text-black text-4xl">&#10095;</span> {/* Right arrow */}
            </div>

            {/* Slides */}
            {content.map((item, index) => (
                <div
                    key={index}
                    className={`absolute w-full h-full transition-opacity duration-1000 ease-in-out ${currentIndex === index ? "opacity-100" : "opacity-0"}`}
                >
                    <div className="flex flex-col justify-center items-center h-auto p-16 text-center mt-8">
                        <h2 className="text-[34px] text-[#1E3A8A] leading-[42px] font-medium text-center mt-16">{item.quote}</h2>
                        <p className="text-[18px] text-[#000] leading-[28px] font-regular text-center mt-10 font-medium">{item.author}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Slide;
